import { createSlice } from "@reduxjs/toolkit";

const dishConfigManagementSlice = createSlice({
    name: 'dishConfigManagement',
    initialState: {
        data: [],
        isLoading: false
    },
    reducers: {
        startLoading: (state) => { state.isLoading = true; },
        stopLoading: (state) => { state.isLoading = false; },
        getUpdateDishConfig: (state, action) => { state.data = action.payload; },
    }
});

const dishConfigManagementActions = dishConfigManagementSlice.actions;

export { dishConfigManagementActions };
export default dishConfigManagementSlice.reducer;